import { createAction, props } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { IAVCFrequencyResponse } from '../models/avc-frequency.model';

export const loadAVCFrequencies = createAction('[AVCFrequencies] Load AVCFrequencies');

export const loadAVCFrequenciesSuccess = createAction(
  '[AVCFrequencies] Load AVCFrequencies Success',
  props<{ response: IAVCFrequencyResponse[] }>()
);

export const loadAVCFrequenciesFailure = createAction(
  '[AVCFrequencies] Load AVCFrequencies Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
